import { render, staticRenderFns } from "./driverLicenseDialog.vue?vue&type=template&id=5b80b832&scoped=true"
import script from "./driverLicenseDialog.vue?vue&type=script&lang=js"
export * from "./driverLicenseDialog.vue?vue&type=script&lang=js"
import style0 from "./driverLicenseDialog.vue?vue&type=style&index=0&id=5b80b832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80b832",
  null
  
)

export default component.exports